// Token encryption for overlay URLs is disabled.
// Tokens are passed through unchanged so existing overlay links keep working.

export const encryptToken = async (token: string): Promise<string> => token;

export const decryptToken = async (encryptedToken: string): Promise<string> => encryptedToken;

export const isEncryptedToken = (_token: string): boolean => false;
